import { Card, Column, Columns, Stack } from 'braid-design-system';

import { useAccountContext } from 'src/modules/ApiClient';
import {
  isActiveOrExpiredJob,
  isDraftJobItem,
  isPositiveNumber,
} from 'src/utils/job';

import {
  JobActions,
  JobOverflowMenu,
  type JobFieldProps,
  JobStatus,
  JobTitleAndLocation,
  JobNumOfCandidatesMobile,
} from './JobItemComponents';

const JobItemMobile = ({ job, listPosition }: JobFieldProps) => {
  const { data: accountContext } = useAccountContext();

  if (!accountContext) {
    return null;
  }

  const isDraft = isDraftJobItem(job);

  let status;
  let daysRemaining;
  if (!isDraft) {
    status = job.status;
    daysRemaining = job.daysRemaining;
  }

  const permissions = accountContext.currentAdvertiser.permissionOptions;

  return (
    <Card>
      <Stack space="large">
        <Columns space="none">
          <Column>
            <JobStatus
              jobId={job.id}
              status={status}
              daysRemaining={daysRemaining}
              isDraft={isDraft}
            />
          </Column>

          <Column>
            {!isDraft && (
              <JobOverflowMenu
                job={job}
                listPosition={listPosition}
                permissions={permissions}
              />
            )}
          </Column>
        </Columns>

        <JobTitleAndLocation
          job={job}
          listPosition={listPosition}
          maxLines={1}
        />
        {!isDraft && (
          <>
            {job.postType === 'DIRECT' &&
              isActiveOrExpiredJob(job) &&
              isPositiveNumber(job.candidatesCount) && (
                <JobNumOfCandidatesMobile
                  job={job}
                  listPosition={listPosition}
                />
              )}
          </>
        )}

        <JobActions
          job={job}
          listPosition={listPosition}
          permissions={permissions}
        />
      </Stack>
    </Card>
  );
};

export default JobItemMobile;
